import { Outlet } from 'react-router-dom'
import { Sidebar } from './Sidebar'
import { TopBar } from './TopBar'
import { ContextBar } from './ContextBar'
import { CommandPalette } from '../components/CommandPalette'
import { Toast } from '../components/Toast'

export function AppShell() {
  return (
    <div className="app">
      <Sidebar />
      <div className="main">
        <TopBar />
        <ContextBar />
        <div className="content">
          <Outlet />
        </div>
      </div>
      <CommandPalette />
      <Toast />
    </div>
  )
}
